module.exports = __webpack_public_path__ + "static/media/hryvnia.e2f5be47.svg";